import React, { useCallback, useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { Input } from 'reactstrap'

import { operator as operatorApi } from 'api'
import withModule from 'hocs/withModule'
import { InputControls } from 'components/common'
import ChannelPriorityList from './ChannelPriorityList'

/**
 * @param {object} props
 * @param {boolean} props.isAutomaticAssigned
 * @param {number} props.maxConversationAssigned
 * @param {[object]} props.channelPriority
 * @param {function} props.setOperator
 */
const OperatorAutomaticAssigment = (props) => {
  const { isAutomaticAssigned, maxConversationAssigned = 0, operatorId, setOperator, disabled } = props

  const [loading, setLoading] = useState(true)
  const [channels, setChannels] = useState([])
  const [priority, setPriority] = useState([])

  const getChannels = useCallback(async () => {
    try {
      const { data } = await operatorApi.channels.autoAssignmentPriority(operatorId)

      setChannels(data.list || [])
      setPriority(data.priority || [])
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operatorId])

  useEffect(() => {
    getChannels()
  }, [getChannels])

  return (
    <div>
      <div className='seccion-one operator-asignment-center'>
        <label htmlFor='operator_isautomatic_assigned' className='label'>
          {I18n.t('operator_assigned_automatic')}
        </label>
        <div className='seccion-two'>
          <InputControls
            name='operator_isautomatic_assigned'
            color='secondary'
            value={isAutomaticAssigned || false}
            onChange={(value)=> setOperator({ isAutomaticAssigned: value })}
            disabled={disabled}
          />
        </div>
      </div>
      <div className='seccion-one'>
        <label htmlFor='operator_max_conversations' className='label'>
          {I18n.t('operator_max_assigned_automatic')}
        </label>
        <div className='seccion-two'>
          <Input
            name='operator_max_conversations'
            type='number'
            id='operator_max_conversations'
            style={{
              maxWidth: '80px'
            }}
            min='0'
            value={maxConversationAssigned || 0}
            onChange={({ target }) => setOperator({ maxConversationAssigned: target.value })}
            disabled={disabled}
          />
        </div>
      </div>

      {
        !loading
          ? (
            <ChannelPriorityList
              channels={channels}
              channelsPriority={priority}
              onChange={({ channelsPriority, channels }) => {
                if (channels) {
                  setChannels(channels)
                }
                if (channelsPriority) {
                  setPriority(channelsPriority)
                  setOperator({
                    channelPriority: channelsPriority.map((el, idx) => ({ channelId: el.id, priority: idx }))
                  })
                }
              }}
            />
          )
          : null
      }
    </div>
  )
}

export default withModule(OperatorAutomaticAssigment, 'automaticAssignment')